<footer>
  <div class="container">
    <app-menu-horizontal></app-menu-horizontal>
  </div>
</footer>
